import React from 'react';

export default function IndruMain() {
  return <div className='bg-secondary'>Indru</div>;
}
